<div id="wrapper" #wrapper>
  <div>
    <div id="left-column">
      <div class="title-div">
        <h1 class="aru-title mb-0">Inspection setup</h1>
        <button
          class="btn aru btn-sm btn-primary"
          *ngIf="leftAccordion.active == 'all' && inspection.id"
          (click)="leftAccordion.active = ''">
          Collapse all
        </button>
        <button
          class="btn aru btn-sm btn-primary"
          *ngIf="leftAccordion.active != 'all' && inspection.id"
          (click)="leftAccordion.active = 'all'">
          Expand all
        </button>
      </div>
      <div class="col-md-12">
        <form [formGroup]="form" (submit)="submit()">
          <div [ngStyle]="{ flex: !leftAccordion.active ? 1 : '' }"></div>

          <!--Availability-->
          <div
            class="accordion-button"
            [ngClass]="{ active: isLeftAccordionActive('dueDate') }"
            (click)="toggle(leftAccordion, 'dueDate')">
            <div style="flex: 1">Due Date</div>
            <i
              class="fa"
              [ngClass]="{
                'fa-chevron-down': !isLeftAccordionActive('dueDate'),
                'fa-chevron-up': isLeftAccordionActive('dueDate')
              }"></i>
          </div>
          <div
            class="row col-lg-12 col-md-12"
            style="margin: 0; background-color: white"
            formGroupName="locations"
            *ngIf="isLeftAccordionActive('dueDate')">
            <!--Due Date-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="col-lg-2 col-md-4 pl-0 titles">Due Date</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-4 col-md-4 form-group">
                    <app-datepicker-input
                      [inputLabel]="'Due Date'"
                      [formControl]="form.get('locations.dueDate')"></app-datepicker-input>

                    <span *ngIf="form.get('locations').get('dueDate').errors?.dateOutOfRange" class="text-danger">
                      Date is out of range.
                    </span>
                  </div>
                  <div class="col-lg-2 col-md-2 form-group custom-switch" style="margin-top: 35px">
                    <input type="checkbox" formControlName="forecasted" class="custom-control-input" id="forecasted" />
                    <label class="custom-control-label" for="forecasted">Forecasted</label>
                  </div>
                  <div class="col-lg-4 col-md-4 form-group"></div>
                </div>
                <div class="row" *ngIf="!inspection.id">
                  <div class="col-lg-4 col-md-4">
                    <button class="btn aru btn-primary" (click)="toggle(leftAccordion, 'customer')">Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Customer-->
          <div
            class="accordion-button"
            style="margin-top: 20px"
            [ngClass]="{ active: isLeftAccordionActive('customer') }"
            (click)="toggle(leftAccordion, 'customer')">
            <div style="flex: 1">Customer</div>
            <i
              class="fa"
              [ngClass]="{
                'fa-chevron-down': !isLeftAccordionActive('customer'),
                'fa-chevron-up': isLeftAccordionActive('customer')
              }"></i>
          </div>
          <div
            class="row col-lg-12 col-md-12"
            style="margin: 0; background-color: white"
            *ngIf="isLeftAccordionActive('customer')">
            <!-- Policy-->
            <div
              formGroupName="policy"
              class="col-lg-12 col-md-12 pr-0"
              style="display: flex; margin-top: 30px"
              *ngIf="activeTab == 'customer'">
              <div class="col-lg-2 col-md-4 pl-0 titles">Policy</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-2 form-group">
                    <label>Product Type</label>
                    <select
                      class="form-control"
                      formControlName="productType"
                      dropdown
                      [ngClass]="getValidationClass('policy.productType')">
                      <option
                        *ngFor="let productType of productTypes; trackBy: trackByProductType"
                        [ngValue]="productType">
                        {{ productType?.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Number</label>
                    <ng-select
                      [items]="policies$ | async"
                      [addTag]="inspection.id ? null : policyAddTagFn"
                      bindLabel="number"
                      bindValue="number"
                      [clearable]="!inspection.id"
                      [trackByFn]="policyTrackByFn"
                      [loading]="policyLoading"
                      addTagText="Add new policy"
                      [minTermLength]="2"
                      [typeahead]="policyInput$"
                      [typeaheadMinLength]="9999"
                      (change)="onPolicySelect($event)"
                      formControlName="number">
                      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                        <span>{{ item.number }} | {{ item.customer.name }}</span>
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item">
                        <span>{{ item.number }}</span>
                        <span *ngIf="item.customer?.name"> | {{ item.customer.name }}</span>
                      </ng-template>
                    </ng-select>
                    <span
                      style="font-size: 0.8em"
                      *ngIf="form.get('policy.id').value && form.get('policy.number').valid">
                      *You are creating an inspection for an existing policy
                    </span>
                    <span
                      style="font-size: 0.8em"
                      *ngIf="!form.get('policy.id').value && form.get('policy.number').valid">
                      *You are creating a new policy
                    </span>
                    <span style="color: #dc3e3e" *ngIf="form.get('policy.number').hasError('policyNumber')">
                      {{ form.get('policy.number').errors?.policyNumber }}
                    </span>
                  </div>
                  <div class="col-lg-4 form-group">
                    <app-datepicker-input
                      [validationStyle]="false"
                      [inputLabel]="'Effective Date'"
                      [formControl]="form.get('policy').get('effectiveDate')"></app-datepicker-input>
                    <span
                      style="font-size: 0.8em; color: #dc3e3e"
                      *ngIf="form.get('locations').get('dueDate').errors?.dateOutOfRange">
                      Date is out of range
                    </span>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="name">Policy Group</label>
                      <ng-select
                        #ngSelectComponent
                        formControlName="group"
                        [items]="groups"
                        [addTag]="addTagFn"
                        [hideSelected]="true"
                        addTagText="Add new group"
                        placeholder="Select or add a group"
                        bindLabel="name"
                        [ngClass]="getValidationClass('policy.group')"
                        (change)="onGroupSelected($event)"
                        (search)="onSearch($event)"
                        (clear)="onClearSearch()">
                        <ng-template ng-option-tmp let-item="item">
                          <span [ngClass]="item.class">{{ item.name }}</span>
                        </ng-template>
                      </ng-select>
                      <span style="font-size: 0.8em">
                        *By changing Policy Group you are affecting all inspections for the selected policy
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!-- Customer-->
            <div
              class="col-lg-12 col-md-12 pr-0"
              style="display: flex; margin-top: 30px"
              *ngIf="activeTab == 'customer'"
              formGroupName="policy">
              <div class="col-lg-2 col-md-4 pl-0 titles">Customer</div>
              <div class="col-lg-10 col-md-8 pr-0" formGroupName="customer">
                <div class="row">
                  <div class="col-lg-12 form-group">
                    <label>Customer Name</label>
                    <ng-select
                      [items]="customers$ | async"
                      bindLabel="displayName"
                      [addTag]="customerAddTagFn"
                      [trackByFn]="customerTrackByFn"
                      [loading]="customerLoading"
                      addTagText="Add new customer"
                      [minTermLength]="2"
                      [typeahead]="customerInput$"
                      [typeaheadMinLength]="9999"
                      (change)="onCustomerSelect($event)"
                      formControlName="name">
                    </ng-select>
                    <span style="font-size: 0.8em" *ngIf="form.get('policy.customer.id').value">
                      *You are creating a policy for an existing customer
                    </span>
                    <span style="font-size: 0.8em" *ngIf="!form.get('policy.customer.id').value">
                      *You are creating a new customer
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>
            <div
              class="col-lg-12 col-md-12 pr-0"
              style="display: flex; margin-top: 30px"
              *ngIf="activeTab == 'customer'">
              <div class="col-lg-2 col-md-4 pl-0 titles">Contact</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 form-group">
                    <label>Name</label>
                    <ng-select
                      [items]="contacts"
                      bindLabel="name"
                      bindValue="id"
                      [addTag]="contactAddTagFn"
                      [trackByFn]="contactTrackByFn"
                      [loading]="contactLoading"
                      addTagText="Add new contact"
                      [typeahead]="contactInput$"
                      (clear)="getContactsByCustomerId()"
                      [typeaheadMinLength]="9999"
                      (change)="onContactSelect($event)"
                      (search)="onContactSearch($event)"
                      formControlName="contactId">
                      <ng-template ng-option-tmp let-item="item">
                        <div *ngIf="!item.name">{{ item }}</div>
                        <div *ngIf="item.name">
                          {{ item.name }}
                          <span *ngIf="item.duplicate">
                            - <span class="fa fa-envelope"> {{ item.email }}</span> -
                            <span class="fa fa-phone"> {{ item.phone }}</span>
                          </span>
                        </div>
                      </ng-template>
                      <ng-template ng-footer-tmp *ngIf="contactViewMore">
                        <div class="d-flex justify-content-between align-items-center">
                          <button class="view-more-style" (click)="onContactViewMore($event)">View more</button>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Email</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="contactEmail"
                      [ngClass]="getValidationClass('contactEmail')" />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="contactPhone"
                      [ngClass]="getValidationClass('contactPhone')" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!-- Broker-->
            <div
              formGroupName="policy"
              class="col-lg-12 col-md-12 pr-0"
              style="display: flex; margin-top: 30px; margin-bottom: 25px"
              *ngIf="activeTab == 'customer'">
              <div class="col-lg-2 col-md-4 pl-0 titles">Broker</div>
              <div formGroupName="broker" class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 form-group" *ngIf="!form.get('policy.id').value && !inspection.id">
                    <label>Name</label>
                    <ng-select
                      [items]="brokers$ | async"
                      bindLabel="name"
                      [addTag]="brokerAddTagFn"
                      [trackByFn]="brokerTrackByFn"
                      [loading]="brokerLoading"
                      addTagText="Add new broker"
                      [minTermLength]="2"
                      [typeahead]="brokerInput$"
                      [typeaheadMinLength]="9999"
                      (change)="onBrokerSelect($event)"
                      formControlName="name">
                    </ng-select>
                    <span style="font-size: 0.8em" *ngIf="form.get('policy.broker.id').value">
                      *You are creating a policy for an existing broker
                    </span>
                    <span style="font-size: 0.8em" *ngIf="!form.get('policy.broker.id').value">
                      *You are creating a new broker
                    </span>
                  </div>
                  <div class="col-lg-12 form-group" *ngIf="form.get('policy.id').value || inspection.id">
                    <label>Name</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      [ngClass]="getValidationClass('policy.broker.name')" />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Email</label>
                    <input
                      formControlName="email"
                      class="form-control"
                      [ngClass]="getValidationClass('policy.broker.email')" />
                  </div>
                  <div class="col-lg-6 form-group">
                    <label>Phone</label>
                    <input
                      formControlName="phone"
                      class="form-control"
                      [ngClass]="getValidationClass('policy.broker.phone')" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-4">
                    <button
                      class="btn aru btn-primary"
                      (click)="toggle(leftAccordion, 'locations')"
                      [disabled]="!isPolicyValid()">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Locations-->
          <div
            class="accordion-button"
            style="margin-top: 20px"
            [ngClass]="{ active: isLeftAccordionActive('locations') }"
            (click)="toggle(leftAccordion, 'locations')">
            <div style="flex: 1">Locations</div>
            <i
              class="fa"
              [ngClass]="{
                'fa-chevron-down': !isLeftAccordionActive('locations'),
                'fa-chevron-up': isLeftAccordionActive('locations')
              }"></i>
          </div>
          <div
            class="row col-lg-12 col-md-12"
            style="margin: 0; background-color: white"
            *ngIf="isLeftAccordionActive('locations')">
            <!-- Inspection Version-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px">
              <div class="col-lg-2 col-md-4 pl-0 titles">Inspection Version</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-6 col-md-6 form-group">
                    <label style="display: flex; justify-content: space-between"
                      >Version name
                      <span>
                        <a href="#" (click)="refreshVersions(); $event.preventDefault()" *ngIf="!disableVersionButtons"
                          >Refresh</a
                        >
                        <a href="#" (click)="customizeVersion(); $event.preventDefault()" *ngIf="!disableVersionButtons"
                          >Customize</a
                        >
                        <a href="/version" target="_blank">Create new</a>
                      </span>
                    </label>
                    <select class="form-control" formControlName="version" [ngClass]="getValidationClass('version')">
                      <option *ngFor="let v of versions" [ngValue]="v" [disabled]="!v.isValid">
                        {{ inspection?.versionId == v.id ? '(current) ' : '' }}{{ v.name
                        }}{{ !v.isValid ? ' (invalid)' : '' }}
                        {{ v.tags?.length ? '[' + v.tags + ']' : '' }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Purpose</label>
                    <select class="form-control" formControlName="purpose" [ngClass]="getValidationClass('purpose')">
                      <option *ngFor="let p of InspectionPurpose | keyvalue" [ngValue]="p.value">
                        {{ p.value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!-- Items to inspect-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="locations">
              <div class="col-lg-2 col-md-3 pl-0 pl-0 titles">Items to inspect</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-md-12 form-group">
                    <table class="items-table col-md-12">
                      <thead>
                        <div class="row">
                          <div class="col-md-2 header">Item Type</div>
                          <div class="col-md-2 header">Quantity</div>
                          <div class="col-md-2 header">Custom Names</div>
                          <div class="col-md-6"></div>
                        </div>
                      </thead>
                      <tbody>
                        <div *ngFor="let info of form.get('locations.items').value">
                          <div class="row">
                            <div class="col-md-2 column">{{ info.item?.name }}</div>
                            <div class="col-md-2 column">
                              <input
                                class="form-control"
                                [formControl]="info.quantity"
                                [ngClass]="getControlValidationClass(info.quantity)"
                                type="number"
                                [attr.min]="info.item?.minInstances"
                                [attr.max]="info.item?.maxInstances"
                                style="width: 65px" />
                            </div>

                            <div *ngIf="info.customNames" class="col-md-2 column">
                              <div class="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  class="custom-control-input"
                                  [formControl]="info.customNames"
                                  [id]="'customSwitch' + (info.id || info.item?.id)" />
                                <label
                                  class="custom-control-label"
                                  [for]="'customSwitch' + (info.id || info.item?.id)"></label>
                              </div>
                            </div>

                            <div class="col-md-6" *ngIf="!info.customNames?.value"></div>

                            <div class="col-md-6 pl-0 column" *ngIf="info.customNames?.value">
                              <ng-container *ngFor="let name of info.namesInputs; index as i">
                                <input
                                  class="form-control"
                                  style="margin-bottom: 10px"
                                  [placeholder]="info?.item?.name + ' #' + (i + 1)"
                                  [ngClass]="getControlValidationClass(name)"
                                  [formControl]="name" />
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!--Address-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="locations">
              <div class="col-lg-2 col-md-4 pl-0 titles">Address</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-3 col-md-3 form-group">
                    <label>Location ID</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="locationId"
                      maxlength="3"
                      [ngClass]="getValidationClass('locations.locationId')" />
                  </div>
                  <div class="col-lg-9 col-md-9 form-group">
                    <label>Address</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="address"
                      [ngClass]="getValidationClass('locations.address')" />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>City</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="city"
                      [ngClass]="getValidationClass('locations.city')" />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>State</label>
                    <select
                      class="form-control"
                      formControlName="state"
                      [ngClass]="getValidationClass('locations.state')">
                      <option *ngFor="let s of usStates" [value]="s">{{ s }}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Zip</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="zip"
                      [ngClass]="getValidationClass('locations.zip')" />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <button
                      type="button"
                      class="btn aru btn-sm btn-primary ml-0"
                      style="margin-top: 29px; width: 100%; height: 35px; padding-top: 6px"
                      (click)="updateLocationFromAddress(true)"
                      [disabled]="this.disableDelete">
                      <i class="fa fa-location-arrow"></i> &nbsp; Update map from address
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Border-->
            <div class="col-lg-12 col-md-12 col-sm-12 pr-0" style="display: flex">
              <div class="col-lg-2 col-md-4 border-d"></div>
              <div class="col-lg-10 col-md-8 border-d"></div>
            </div>

            <!--Map-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px" formGroupName="locations">
              <div class="col-lg-2 col-md-4 pl-0 titles">Map</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Latitude</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="lat"
                      [ngClass]="getValidationClass('locations.lat')" />
                  </div>
                  <div class="col-lg-6 col-md-6 form-group">
                    <label>Longitude</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="lng"
                      [ngClass]="getValidationClass('locations.lng')" />
                  </div>
                  <div class="col-md-12">
                    <div style="width: 100%; height: 400px; margin-bottom: 20px">
                      <app-mapbox
                        (result)="onResult($event)"
                        (load)="setMap($event)"
                        (styleLoaded)="styleLoaded()"></app-mapbox>
                      <button type="button" class="update-map btn" (click)="updateMapFromForm()">Reset Map</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Notes-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="col-lg-2 col-md-3 pl-0 pl-0 titles"></div>
              <div class="col-lg-10 col-md-8">
                <div class="row">
                  <div class="col-lg-4 col-md-4">
                    <button
                      class="btn aru btn-primary"
                      (click)="toggle(leftAccordion, 'vendor')"
                      [disabled]="!this.isLocationsValid()">
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Assignments-->
          <div
            class="accordion-button"
            style="margin-top: 20px"
            [ngClass]="{ active: isLeftAccordionActive('vendor') }"
            (click)="toggle(leftAccordion, 'vendor')">
            <div style="flex: 1">Assignments</div>
            <i
              class="fa"
              [ngClass]="{
                'fa-chevron-down': !isLeftAccordionActive('vendor'),
                'fa-chevron-up': isLeftAccordionActive('vendor')
              }"></i>
          </div>
          <div
            class="row col-lg-12 col-md-12"
            style="margin: 0; background-color: white"
            *ngIf="isLeftAccordionActive('vendor')">
            <!--Vendor-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="col-lg-2 col-md-3 pl-0 pl-0 titles">Vendor</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row" formGroupName="vendor">
                  <div class="col-lg-12 col-md-12 form-group">
                    <label>Assign to vendor (optional)</label>
                    <ng-select
                      [items]="vendors$ | async"
                      bindLabel="name"
                      [trackByFn]="vendorTrackByFn"
                      [loading]="vendorLoading"
                      [minTermLength]="2"
                      [typeahead]="vendorInput$"
                      [ngClass]="getValidationClass('vendor')"
                      [typeaheadMinLength]="9999"
                      (change)="onVendorSelect($event)"
                      formControlName="name"
                      (clear)="clearVendor()">
                      <ng-template ng-footer-tmp>
                        <a *ngIf="!vendorViewMoreClicked" (click)="loadAllVendors(false)" class="view-more-links">
                          View more
                        </a>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div formGroupName="inspector">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 form-group">
                      <label>Assign to inspector (optional)</label>
                      <ng-select
                        [items]="vendorInspectors"
                        bindLabel="name"
                        [trackByFn]="inspectorTrackByFn"
                        [minTermLength]="2"
                        [ngClass]="getValidationClass('inspector')"
                        (clear)="clearInspector()"
                        [loading]="inspectorLoading"
                        (change)="onInspectorSelect($event)"
                        formControlName="name">
                        <ng-template ng-option-tmp let-item="item">
                          <div class="d-flex justify-content-between" *ngIf="item && item.distanceInMiles">
                            <span>
                              {{ item.name }}
                              <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                            </span>
                            <span class="d-flex align-items-center" style="width: 27%; justify-content: space-between">
                              <small class="pr-4 pb-1" *ngIf="item.distanceInMiles"
                                >Open Inspections: {{ item.assignmentMadeCount }}</small
                              >

                              <span class="star-container" [attr.data-tooltip]="item.rating + ' / 10'">
                                <ngx-stars
                                  class="blue-stars"
                                  [maxStars]="5"
                                  [initialStars]="item.rating / 2"
                                  color="#2763cd"
                                  [readonly]="true"></ngx-stars>
                                <small> &nbsp; ({{ item.inspectionRatingCount }})</small>
                              </span></span
                            >
                          </div>
                        </ng-template>

                        <ng-template ng-label-tmp let-item="item">
                          <div>
                            {{ item.name }}
                            <small *ngIf="item.distanceInMiles"> ({{ item.distanceInMiles }})</small>
                          </div>
                        </ng-template>

                        <ng-template ng-footer-tmp>
                          <a *ngIf="!viewMoreClicked" (click)="viewMoreInspectors()" class="view-more-link"
                            >View more</a
                          >
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                  <div class="row" *ngIf="this.form.get('inspector.id').value">
                    <div class="col-lg-6 col-md-6 form-group">
                      <label>Inspector email</label>
                      <input class="form-control" formControlName="email" />
                    </div>
                    <div class="col-lg-6 col-md-6 form-group">
                      <label>Inspector phone</label>
                      <input class="form-control" formControlName="phone" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Admin-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="col-lg-2 col-md-3 pl-0 pl-0 titles">Admin</div>
              <div class="col-lg-10 col-md-8 pr-0">
                <div class="row">
                  <div class="col-lg-12 col-md-12 form-group">
                    <label>Assignee (optional)</label>
                    <ng-select
                      class="assignee-filter"
                      [items]="assignees"
                      bindLabel="name"
                      [trackByFn]="vendorTrackByFn"
                      (change)="onAssigneeSelect($event)"
                      formControlName="assignee"
                      notFoundText="No assignee found"
                      [disabled]="!canAssign"
                      (clear)="clearAssignee()">
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div class="assignee-option">
                          <div class="avatar">{{ getInitials(item.name) }}</div>
                          <div class="details">
                            <span class="name">{{ item.name }}</span>
                            <span *ngIf="item.email" class="email" [title]="item.email">{{ item.email }}</span>
                          </div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Attachments-->
          <div
            class="accordion-button"
            style="margin-top: 20px"
            [ngClass]="{ active: isLeftAccordionActive('attachments') }"
            *ngIf="canSeeFiles && inspection.id"
            (click)="toggle(leftAccordion, 'attachments')">
            <div style="flex: 1">Attachments</div>
            <i
              class="fa"
              [ngClass]="{
                'fa-chevron-down': !isLeftAccordionActive('customer'),
                'fa-chevron-up': isLeftAccordionActive('customer')
              }"></i>
          </div>
          <div
            *ngIf="canSeeFiles"
            class="row col-lg-12 col-md-12"
            style="margin: 0; background-color: white; padding: 20px"
            [hidden]="!isLeftAccordionActive('attachments')">
            <div *ngIf="inspection.boxFolderId" style="width: 100%; height: 500px">
              <iframe #boxIframe [src]="boxUrl" style="border: 0; width: 100%; height: 100%"></iframe>
            </div>

            <div *ngIf="!inspection.boxFolderId">
              <button
                class="btn aru btn-sm btn-primary"
                (click)="setupInspectionFolder(); $event.preventDefault()"
                *ngIf="!creatingFolder"
                style="width: 200px">
                Set up Storage
              </button>
              <button class="btn aru btn-sm btn-primary" [disabled]="true" *ngIf="creatingFolder" style="width: 200px">
                Setting up Storage...
              </button>
            </div>
            <br />

            <!-- <div>
              <button class="btn aru btn-sm btn-primary" (click)="addAttachment();$event.preventDefault();" style="width: 200px;">Add
                Attachment</button>
              <br />
              <br />
              <p>* You can upload multiple files at the same time.
                <br />
                * Once the popup is open, you can navigate away from this page and the upload won't be interrupted.
              </p>
            </div> -->

            <div>
              Upload PDF for image extraction:
              <input #pdfFile type="file" accept=".pdf" (change)="pdfFileChanged($event.target?.files?.[0])" />
              <button
                *ngIf="pdfFile.value && !uploadingPdf"
                style="margin: 0; margin-left: 5px"
                type="button"
                class="aru btn btn-primary"
                (click)="uploadSelectedPdf(boxIframe)">
                Upload
              </button>
              <button
                *ngIf="uploadingPdf"
                disabled
                style="margin: 0; width: auto; margin-left: 5px"
                type="button"
                class="aru btn btn-primary">
                Please wait
              </button>
            </div>
          </div>

          <!-- Sync Problems-->
          <div
            class="accordion-button"
            style="margin-top: 20px"
            [ngClass]="{ active: isLeftAccordionActive('syncProblems') }"
            (click)="toggle(leftAccordion, 'syncProblems')"
            *ngIf="inspection.id">
            <div style="flex: 1">Sync Problems</div>
            <i
              class="fa"
              [ngClass]="{
                'fa-chevron-down': !isLeftAccordionActive('syncProblems'),
                'fa-chevron-up': isLeftAccordionActive('syncProblems')
              }"></i>
          </div>
          <div
            class="row col-lg-12 col-md-12"
            style="margin: 0; background-color: white"
            *ngIf="isLeftAccordionActive('syncProblems')">
            <!-- Sync Problems-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="col-lg-2 col-md-2 pl-0 pl-0 titles">Sync Problems</div>
              <div class="col-lg-9 col-md-9">
                <div class="row">
                  <div class="col-lg-12 col-md-12 form-group">
                    <div style="display: grid; grid-template-columns: 650px 30px; align-items: center">
                      <label
                        >Did this inspection require manual intervention to be completed (recovery or validation
                        problems)?</label
                      >
                      <input
                        type="checkbox"
                        class="form-control"
                        formControlName="hadSyncProblems"
                        style="height: 25px; margin-top: -5px" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-1 col-md-1"></div>
            </div>
          </div>

          <!-- Buttons-->
          <div class="row col-lg-12 col-md-12">
            <!-- Save Delete Archive-->
            <div class="col-lg-12 col-md-12 pr-0" style="display: flex; margin-top: 30px; margin-bottom: 25px">
              <div class="row" *ngIf="canEdit">
                <div class="form-group">
                  <button
                    class="btn aru btn-primary"
                    [disabled]="loading || noQuestions || !form.valid || !areNamesValid() || inspection.archived">
                    Save
                  </button>
                  <button
                    class="btn aru btn-outline-danger"
                    [disabled]="disableDelete || inspection.archived || !inspection.id"
                    (click)="remove($event)">
                    Delete</button
                  >&nbsp;

                  <button
                    class="btn aru btn-outline-danger"
                    *ngIf="!inspection.archived"
                    [disabled]="!inspection.id"
                    (click)="archive($event)">
                    Archive
                  </button>

                  <button
                    class="btn aru btn-outline-success"
                    *ngIf="inspection.archived"
                    [disabled]="!inspection.id"
                    (click)="restore($event)">
                    Restore
                  </button>

                  <button
                    class="btn aru btn-outline-success"
                    style="width: auto"
                    *ngIf="inspection?.id"
                    routerLink="/inspection/form/add"
                    [queryParams]="{ duplicate: inspection.id }"
                    (click)="$event.preventDefault()">
                    Duplicate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="right-column" *ngIf="inspection.id">
      <div class="title-div">
        <b>More information</b>
      </div>
      <p style="margin-left: 20px; margin-bottom: 0">
        Policy Number: <b>{{ inspection.policyNumber }}</b>
      </p>
      <p style="margin-left: 20px; margin-bottom: 0">
        Customer Name: <b>{{ inspection.policy?.customer?.name }}</b>
      </p>
      <p *ngIf="!inspection?.lastSynced" style="margin-left: 20px; margin-bottom: 0">This Inspection was not synced.</p>
      <p style="margin-left: 20px; margin-bottom: 0">Coordinate relevance: {{ inspection.locationRelevance }}</p>
      <div class="row" style="margin: 20px 0 0 20px">
        <div class="col-md-12 pl-0">
          Status:
          <span
            style="font-weight: bold"
            [ngStyle]="{ color: statusAsText(inspection) === 'Accepted' ? '#4dbd74' : '#2763CD' }"
            >{{ statusAsText(inspection) }}
            <span *ngIf="inspection.archived" style="color: #dc3e3e">(Archived)</span>
            <span class="badge badge-pill badge-danger" *ngIf="inspection.status == InspectionStatus.INVALID_SYNC"
              >Invalid</span
            >
          </span>
          <p *ngIf="statusAsText(inspection) === 'Ready to be assigned'" class="status-info">
            for inspection on {{ dateAsString(inspection.dueDate) }}
          </p>

          <p *ngIf="statusAsText(inspection) === 'Assignment made'" class="status-info">
            to {{ inspection.vendor?.name }} {{ inspection.inspector ? '/ ' + inspection.inspector.name : '' }} for
            inspection on {{ dateAsString(inspection.dueDate) }}
          </p>

          <p *ngIf="statusAsText(inspection) === 'Waiting'" class="status-info">
            until {{ dateAsString(inspection.dueDate) }}
            <span *ngIf="inspection.vendor">
              to be completed by {{ inspection.vendor?.name }}
              {{ inspection.inspector ? '/ ' + inspection.inspector.name : '' }}
            </span>
          </p>

          <p *ngIf="statusAsText(inspection) === 'Due completion'" class="status-info">
            <span *ngIf="inspection?.lastSynced">
              Sync in progress since {{ dateAsString(inspection.lastSynced) }}
              <br />
            </span>
            by {{ inspection.vendor?.name }} {{ inspection.inspector ? '/ ' + inspection.inspector.name : '' }} since
            {{ dateAsString(inspection.dueDate) }}
          </p>

          <p *ngIf="statusAsText(inspection) === 'Completed and needs review'" class="status-info">
            on {{ dateAsString(inspection.completed) }}, {{ daysSince(inspection.completed) }} days since completed
          </p>

          <p *ngIf="statusAsText(inspection) === 'Rejected'" class="status-info">
            on {{ dateAsString(inspection.rejected) }}, {{ daysSince(inspection.rejected) }} days ago
          </p>

          <p *ngIf="statusAsText(inspection) === 'Accepted'" class="status-info">
            on {{ dateAsString(inspection.accepted) }}, {{ daysSince(inspection.accepted) }} days ago
          </p>

          <p *ngIf="statusAsText(inspection) === 'Completed'" class="status-info">
            on {{ dateAsString(inspection.paid) }}, {{ daysSince(inspection.paid) }} days ago
          </p>
        </div>
      </div>
      <div class="row" style="margin: 20px 0 0 20px">
        <div class="col-md-12 pl-0">
          <div *ngIf="statusAsText(inspection) === 'No date assigned'">
            <button
              class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0 pl-0 pr-0"
              style="width: 175px"
              (click)="setLeftAccordionActive('dueDate')">
              Add Due Date</button
            ><br />
            <button
              *ngIf="!inspection?.vendor || !inspection?.inspector"
              class="btn aru btn-sm btn-primary ml-0 mr-0 pl-0 pr-0"
              style="width: 175px"
              (click)="setLeftAccordionActive('vendor')">
              Assign vendor/inspector
            </button>
          </div>

          <div
            *ngIf="
              (statusAsText(inspection) === 'Waiting' && !inspection?.vendor) ||
              statusAsText(inspection) === 'Ready to be assigned'
            ">
            <button
              class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0 pl-0 pr-0"
              style="width: 175px"
              (click)="setLeftAccordionActive('vendor')">
              Assign vendor/inspector
            </button>
          </div>

          <div *ngIf="shouldShowEmailModal()">
            <button class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0 pl-0 pr-0" (click)="showEmailModal(inspection)">
              Send email
            </button>
            <button
              *ngIf="statusAsText(inspection) === 'Rejected'"
              class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0 pl-0 pr-0"
              [routerLink]="'/inspection/review/main/' + inspection.id"
              [queryParams]="{ right: 'overview' }">
              Review
            </button>
          </div>

          <div *ngIf="['Completed and needs review', 'Accepted', 'Completed'].includes(statusAsText(inspection))">
            <button
              class="btn aru btn-sm btn-primary ml-0 mt-0 pl-0 pr-0"
              [routerLink]="'/inspection/review/main/' + inspection.id"
              [queryParams]="{ right: 'overview' }">
              Review
            </button>
            <button
              *ngIf="statusAsText(inspection) === 'Accepted'"
              class="btn aru btn-sm btn-primary ml-0 mr-0 mt-0 pl-0 pr-0"
              (click)="markAsPaid()">
              Mark as paid
            </button>
          </div>
        </div>
      </div>
      <!--Notes and Changes-->
      <div class="row" style="margin-top: 20px">
        <div class="col-md-12">
          <!--Tab Navigation-->
          <div class="notes-changes-tabs">
            <div class="tab-item" [ngClass]="{ selected: notesChangesTab === 'notes' }" (click)="setActiveTab('notes')">
              <div class="tab-label">Notes</div>
            </div>
            <div
              class="tab-item"
              [ngClass]="{ selected: notesChangesTab === 'changes' }"
              (click)="setActiveTab('changes')">
              <div class="tab-label">Changes</div>
            </div>
          </div>

          <!--Tab Content-->
          <div class="tab-content">
            <div
              class="row col-lg-12 col-md-12 pl-0 pr-0"
              [style.display]="notesChangesTab === 'notes' ? 'block' : 'none'"
              style="margin: 0">
              <div class="col-lg-12 col-md-12 pr-0 pl-0">
                <!-- Add Note Button -->

                <div forScroll>
                  <app-inspection-notes
                    #inspectionNotes
                    (noteClicked)="handleNoteClicked()"
                    [inspectors]="inspectors"></app-inspection-notes>
                </div>
              </div>
            </div>
            <div
              class="row col-lg-12 col-md-12 pl-0 pr-0"
              [style.display]="notesChangesTab === 'changes' ? 'block' : 'none'"
              style="margin: 0">
              <div class="col-lg-12 col-md-12 pr-0 pl-0">
                <div forScroll>
                  <app-inspection-change [changes]="inspection.changes"></app-inspection-change>
                </div>
              </div>
            </div>
          </div>
          <!-- Separator with shadow -->

          <div style="position: fixed; top: 93vh; width: 100%; background: white">
            <div class="content-separator"></div>
            <div class="add-note-button" (click)="showAddNoteModal()">
              <div class="button-text">Add Scheduling Note</div>
              <img src="assets/img/plus.svg" class="plus-icon" alt="plus" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="right-column-empty" *ngIf="!inspection.id"></div>
  </div>
  <app-send-email-inspection #sendEmailModal></app-send-email-inspection>
  <app-version-clone-modal
    #cloneModal
    [version]="version"
    [isCustomVersion]="true"
    [inspection]="inspection"
    (clonedVersion)="setCustomVersion($event)">
  </app-version-clone-modal>
</div>

<div class="modal-overlays" *ngIf="showVendorModal">
  <div class="modal-contents">
    <div class="modal-body">
      <p>No Inspectors for this Vendor match the inspection’s product type. Proceed anyway?</p>
    </div>
    <div class="modal-footers">
      <button type="button" class="btn btn-primary aru" (click)="onConfirm()">Confirm</button>
      <button type="button" class="btn btn-default aru" (click)="onCancel()">Cancel</button>
    </div>
  </div>
</div>

<div class="modal-overlays" *ngIf="showInspectorModal">
  <div class="modal-contents">
    <div class="modal-body">
      <p>This Inspector doesn’t match the inspection’s product type. Proceed anyway?</p>
    </div>
    <div class="modal-footers">
      <button type="button" class="btn btn-primary aru" (click)="onInspectorConfirm()">Confirm</button>
      <button type="button" class="btn btn-default aru" (click)="onInspectorCancel()">Cancel</button>
    </div>
  </div>
</div>

<!-- Add Scheduling Note Modal -->
<app-add-scheduling-note
  *ngIf="showModal"
  [inspectionId]="inspection?.id"
  (closeModal)="hideAddNoteModal()"
  (noteCreated)="onNoteCreated($event)">
</app-add-scheduling-note>
